import { render, staticRenderFns } from "./SaveContact.vue?vue&type=template&id=0c5306ee&scoped=true&"
import script from "./SaveContact.vue?vue&type=script&lang=js&"
export * from "./SaveContact.vue?vue&type=script&lang=js&"
import style0 from "./SaveContact.vue?vue&type=style&index=0&id=0c5306ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5306ee",
  null
  
)

export default component.exports